const bulletinDetail = {
  path: 'bulletinDetail/:bulletinId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/bulletinDetail'], resolve)
}
export default bulletinDetail



// WEBPACK FOOTER //
// ./src/router/pages/student_user/bulletinDetail/index.js